import React from 'react';
import { Label } from '@/components/ui/label';

const CommonTextarea = React.forwardRef(({
  className,
  label,
  id,
  error,
  required = false,
  disableAutofill = false,
  disableFocus = false,
  ...props
}, ref) => {
  return (
    <div className="w-full">
      {label && (
        <Label
          htmlFor={id}
          className={`text-sm font-medium mb-1 inline-block transition-colors duration-200 ${
            error ? 'text-destructive' : 'text-foreground'
          }`}
        >
          {label} {required && <span className="text-destructive">*</span>}
        </Label>
      )}
      <textarea
        ref={ref}
        id={id}
        tabIndex={disableFocus ? -1 : undefined}
        className={`
          flex h-20 w-full rounded-md border bg-background px-3 py-2 text-sm 
          ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 
          focus-visible:ring-ring focus-visible:ring-offset-0 disabled:cursor-not-allowed 
          disabled:opacity-50 transition-all duration-200 resize-none
          ${className || ''} 
          ${error ? 'border-destructive focus-visible:ring-destructive/30' : 'border-input focus-visible:ring-primary/30'} 
        `}
        autoComplete={disableAutofill ? 'off' : props.autoComplete}
        {...props}
      />
      {error && <p className="text-sm text-destructive mt-1 transition-opacity duration-200">{error}</p>}
    </div>
  );
});

CommonTextarea.displayName = 'CommonTextarea';

export { CommonTextarea };